import Vue from 'vue';
import Vuex from 'vuex';
import Components from './modules/components/index.js'

export const UPDATE_PLOTER_CONFIG = 'updatePloterCongig'
export const UPDATE_STAGE_DATA = 'updateStageData'
export const UPDATE_STAGE_SIZE = 'updateStageSize'
export const UPDATE_STAGE_ELEMENTS = 'updateStageElements'
export const UPDATE_PLOTER_STAGE = 'updatePloterStage'

Vue.use(Vuex);
const key = "user";
const isLogin = "isLogin";
const store = new Vuex.Store ({
// state
 state : {
    nowThemeInfo: 'theme', //当前主题
    themes: ['theme1', 'theme2'] ,//所有主题
    ishome: true, //判断是否是主页,防止其他页面触发监听浏览器分辨率变化
    user: null,
    isLogin: 'FALSE',
    //-----plot 开始 ----------
    ploterCfg: {
        readOnly: false,
        businessShape: {
            enable: true,
              requestLoop: 0 // 0为不轮询
        }
    },
    stageData: null,
    stageSize: {
        width: 800,
        height: 600
    },
    stageElements: null,
    ploterStage: null,
    //-----plot 结束 ----------
    listPagePars: new Map(), //查询页的查询条件
},

// 同步操作
 mutations : {
    SAVE_LIST_PAGE_PARS: (state, { path, pars }) => {
      state.listPagePars.set(path, pars);
    },
    RESET_LIST_PAGE_PERS: (state) => {
      state.listPagePars = new Map();
    },


    SET_THEMEINFO(state, theme){
	    state.nowThemeInfo = theme;
    },
    SET_ISHOME(state, is){
        state.ishome = is
    },
    $_setLogin(state, value) {
      state.isLogin = value;
      localStorage.setItem(isLogin, value);
    },
    $_setStorage(state, value) {
        state.user = value;
        localStorage.setItem(key, JSON.stringify(value));
    },
    $_removeStorage(state) {
        state.user = null;
        state.isLogin = "FALSE";
        localStorage.removeItem(key);
        localStorage.removeItem(isLogin);
    },
    //-----plot 开始 ----------
    [UPDATE_PLOTER_CONFIG]: (state, payload) => {
        state.ploterCfg = payload
    },
    [UPDATE_STAGE_DATA]: (state, payload) => {
        state.stageData = payload
    },
    [UPDATE_STAGE_SIZE]: (state, payload) => {
        state.stageSize = payload
    },
    [UPDATE_STAGE_ELEMENTS]: (state, payload) => {
        state.stageElements = payload
    },
    [UPDATE_PLOTER_STAGE]: (state, payload) => {
        state.ploterStage = payload
    }
    //-----plot 结束 ----------
},
 getters : {
    ishome :(state) => state.ishome,
    getStorage: function(state) {
        if(!state.user){
            state.user = JSON.parse(localStorage.getItem(key));
            state.isLogin = localStorage.getItem(isLogin);
        }
        return state.user;
    },
    //-----plot 开始 ----------
    ploterConfig: state => state.ploterCfg,
    wrapStageData: state => state.stageData,
    stageSize: state => state.stageSize,
    stageElements: state => state.stageElements,
    ploterStage: state => state.ploterStage
    //-----plot 结束 ----------
},
actions:{
  saveListPagePars: ({ commit }, { path, pars }) => {
    commit('SAVE_LIST_PAGE_PARS', { path, pars });
  }
},
//-----plot 开始 ----------
 modules : {
    ...Components
}
})
//-----plot 结束 ----------

// const store = () => {
//     return new Vuex.Store({
//         state,
//         mutations,
//         getters,
//         modules
//     });
// };

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js